/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionUserAddress
 */
export interface SubscriptionUserAddress {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUserAddress
     */
    timezone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUserAddress
     */
    state?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUserAddress
     */
    line1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUserAddress
     */
    line2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUserAddress
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUserAddress
     */
    zipCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUserAddress
     */
    country?: string | null;
}

/**
 * Check if a given object implements the SubscriptionUserAddress interface.
 */
export function instanceOfSubscriptionUserAddress(value: object): value is SubscriptionUserAddress {
    return true;
}

export function SubscriptionUserAddressFromJSON(json: any): SubscriptionUserAddress {
    return SubscriptionUserAddressFromJSONTyped(json, false);
}

export function SubscriptionUserAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionUserAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'timezone': json['timezone'] == null ? undefined : json['timezone'],
        'state': json['state'] == null ? undefined : json['state'],
        'line1': json['line1'] == null ? undefined : json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'city': json['city'] == null ? undefined : json['city'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function SubscriptionUserAddressToJSON(json: any): SubscriptionUserAddress {
    return SubscriptionUserAddressToJSONTyped(json, false);
}

export function SubscriptionUserAddressToJSONTyped(value?: SubscriptionUserAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'timezone': value['timezone'],
        'state': value['state'],
        'line1': value['line1'],
        'line2': value['line2'],
        'city': value['city'],
        'zipCode': value['zipCode'],
        'country': value['country'],
    };
}

